import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Box, Container, Fab, Fade, Stack } from '@mui/material';
import { motion, useScroll, useSpring } from 'framer-motion';
import React, { useEffect, useRef, useState } from 'react';

import {
  CanvasBackground,
  HeroSection,
  MaturitySection,
  PlatformFeatures,
  ServicesSection,
  WelcomeFooter,
  WelcomeHeader,
} from './components';

const WelcomePage: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { scrollYProgress } = useScroll();
  const maturitySectionRef = useRef<HTMLDivElement>(null);

  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToMaturitySection = () => {
    maturitySectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <Box sx={{ position: 'relative', overflowX: 'hidden', backgroundColor: '#0b1524' }}>
      <motion.div
        style={{
          scaleX,
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: 4,
          background: 'linear-gradient(90deg, #8AB2C4 0%, #A15A95 50%, #C9704E 100%)',
          transformOrigin: '0%',
          zIndex: 2000,
        }}
      />

      <CanvasBackground />

      <WelcomeHeader />

      <Box component='main'>
        <HeroSection scrollToMaturitySection={scrollToMaturitySection} />

        <Container ref={maturitySectionRef} maxWidth='lg' sx={{ py: { xs: 8, md: 12 } }}>
          <Stack spacing={12}>
            <MaturitySection />
            <PlatformFeatures />
            <ServicesSection />
          </Stack>
        </Container>
      </Box>

      <WelcomeFooter />

      <Fade in={isVisible}>
        <Fab
          color='primary'
          size='medium'
          onClick={scrollToTop}
          sx={{
            position: 'fixed',
            bottom: '2rem',
            right: '2rem',
            zIndex: 1000,
            boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
            '&:hover': {
              transform: 'translateY(-4px)',
              transition: 'transform 0.2s',
            },
          }}
        >
          <ArrowUpwardIcon />
        </Fab>
      </Fade>
    </Box>
  );
};

export default WelcomePage;
